import { defineMessages } from 'react-intl';

const messages = defineMessages({
  myAccount: {
    id: 'menu.myaccount',
    defaultMessage: 'My account',
  },
  myKompleteOffers: {
    id: 'menu.upgrades',
    defaultMessage: 'My KOMPLETE Offers',
  },
  myProductSerials: {
    id: 'menu.registeredproducts',
    defaultMessage: 'My products and serials',
  },
  accountSettings: {
    id: 'menu.accountsettings',
    defaultMessage: 'Name, address, email, password',
  },
  orders: {
    id: 'menu.orderhistory',
    defaultMessage: 'Order history',
  },
  downloads: {
    id: 'menu.updatesdrivers',
    defaultMessage: 'Updates and drivers',
  },
  subscription: {
    id: 'menu.subscription',
    defaultMessage: 'Subscription',
  },
});

export default messages;
